<template>
  <ProfileFactoidContainer>
    <div
      class="sm:max-w-[640px] lg:max-w-[912px] xl:max-w-[505px] 2xl:max-w-[633px] mx-2 mt-2 xl:mx-0 xl:pr-16 xl:ml-2 xl:mb-[47px] 2xl:mb-[63px]"
    >
      <ProfileFactoidInfo :image="image" :name="name" :position="position" />
    </div>
    <div class="lg:mx-2 lg:mb-2 xl:mx-2 xl:mr-2 xl:ml-0 lg:mt-8">
      <ProfileCard :profileCardItems="profileCardItems" />
    </div>
  </ProfileFactoidContainer>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import ProfileFactoidContainer from './ui/ProfileFactoidContainer.vue';
import ProfileFactoidInfo from './ui/ProfileFactoidInfo.vue';
import BaseImage from '@/assets/images/ashley-headshot.jpg';
import ProfileCard from '../ProfileCard/ProfileCard.vue';

export default defineComponent({
  name: 'BaseProfileFactoid',
  components: {
    ProfileFactoidContainer,
    ProfileFactoidInfo,
    ProfileCard,
  },
  props: {
    name: {
      type: String,
      default: 'Ashley Medows',
    },
    position: {
      type: String,
      default: 'HR Manager',
    },
    image: {
      type: String,
      default: BaseImage,
    },
    imageExplainerText: {
      type: String,
      default: '',
      required: true,
    },
    profileCardItems: {
      type: [],
    },
  },
});
</script>
